import React, { useEffect, useState } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Layout() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navItems = [{
    name: 'About',
    path: '/'
  }, {
    name: 'Experiences',
    path: '/experiences'
  }, {
    name: 'Achievements',
    path: '/achievements'
  }, {
    name: 'Contributions',
    path: '/contributions'
  }, {
    name: 'Contacts',
    path: '/contacts'
  }];
  useEffect(() => {
    window.scrollTo(0, 0);
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  return <div className="min-h-screen flex flex-col font-sans bg-slate-50" data-id="element-14">
      <header className="sticky top-0 z-50 bg-navy-900 text-white border-b border-white/10 shadow-xl" data-id="element-15">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 h-24 flex items-center justify-between" data-id="element-16">
          <Link to="/" className="flex items-center gap-4 hover:opacity-90 transition-opacity group" data-id="element-17">
            <div className="w-12 h-12 bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center text-navy-900 font-serif font-bold text-xl shadow-[0_0_15px_rgba(16,185,129,0.4)] group-hover:shadow-[0_0_25px_rgba(16,185,129,0.6)] transition-shadow" data-id="element-18">
              RGF
            </div>
            <span className="font-serif text-3xl font-bold tracking-widest uppercase text-white" data-id="element-19">
              RGF
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-20">
            {navItems.map(item => <Link key={item.name} to={item.path} className={`text-sm font-bold tracking-widest uppercase transition-colors ${location.pathname === item.path ? 'text-emerald-400' : 'text-slate-300 hover:text-white'}`} data-id="element-21">
                {item.name}
              </Link>)}
            <Link to="/contacts" className="px-6 py-3 bg-emerald-500 text-navy-900 text-sm font-bold uppercase tracking-widest hover:bg-emerald-400 transition-colors shadow-lg" data-id="element-22">
              Engage
            </Link>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-slate-300 hover:text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-23">
            {isMobileMenuOpen ? <X size={28} data-id="element-24" /> : <Menu size={28} data-id="element-25" />}
          </button>
        </div>

        {/* Mobile Nav */}
        <AnimatePresence data-id="element-26">
          {isMobileMenuOpen && <motion.nav initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} className="md:hidden bg-navy-800 border-t border-white/10 overflow-hidden" data-id="element-27">
              <div className="px-6 py-6 flex flex-col gap-6" data-id="element-28">
                {navItems.map(item => <Link key={item.name} to={item.path} className={`text-base font-bold tracking-widest uppercase ${location.pathname === item.path ? 'text-emerald-400' : 'text-slate-300'}`} data-id="element-29">
                    {item.name}
                  </Link>)}
              </div>
            </motion.nav>}
        </AnimatePresence>
      </header>

      <main className="flex-grow" data-id="element-30">
        <Outlet data-id="element-31" />
      </main>

      <footer className="bg-navy-900 text-slate-400 py-16 border-t border-white/10 relative overflow-hidden" data-id="element-32">
        <div className="absolute inset-0 bg-grid-pattern opacity-5" data-id="element-33"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-2 gap-12 relative z-10" data-id="element-34">
          <div data-id="element-35">
            <div className="flex items-center gap-4 mb-6" data-id="element-36">
              <div className="w-10 h-10 bg-emerald-500 flex items-center justify-center text-navy-900 font-serif font-bold text-lg" data-id="element-37">
                RGF
              </div>
              <span className="font-serif text-2xl font-bold tracking-widest uppercase text-white" data-id="element-38">
                RGF
              </span>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-slate-300" data-id="element-39">
              Chief Executive | Institutional Strategist | Board Director.
              Directing Fiduciary & Operational Governance Over $3B+ Enterprise
              Ecosystems.
            </p>
          </div>
          <div className="md:text-right flex flex-col md:items-end justify-center" data-id="element-40">
            <p className="text-sm mb-6 text-slate-400" data-id="element-41">
              © {new Date().getFullYear()} RGF. All rights reserved.
            </p>
            <div className="flex gap-6" data-id="element-42">
              <Link to="/contacts" className="text-emerald-400 hover:text-emerald-300 text-sm font-bold uppercase tracking-widest transition-colors" data-id="element-43">
                Initiate Dialogue
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}